import { gql } from '@apollo/client';
import { loader } from 'graphql.macro';

const FRAGMENT = loader('./tceValueFragment.gql');

export const TCE_VALUE_TYPE_NAME = 'TceValue';
export const TCE_VALUE_FRAGMENT_NAME = 'TceValueFragment';
export const TCE_VALUE_FRAGMENT = gql`
    ${FRAGMENT}
`;
